import { useCallback } from "react";

import { Download, Delete } from "@mui/icons-material";

import { DocumentItem } from "@covertree/ui/content/DocumentItem";
import environment from "@environment/variables";
import { PolicyDocument } from "@covertree/agent-portal-graphql";
import { DocumentDisplayName } from "@consts/socotraDocuments";

import { PolicyDetailsContentProps } from "../../types";
import { useDocumentsActions } from "./useDocumentsActions";

export function DocumentsList({ policy }: PolicyDetailsContentProps) {
  const {
    isPolicyRefreshing,
    isRemovePolicyLoading,
    onDocumentDownload,
    onDocumentRemove,
    filterDocumentsToDisplay,
    isDocumentRemovable,
    onValuationReportDownload,
  } = useDocumentsActions(policy.policyLocator);

  const getDocumentsActions = useCallback(
    (document: PolicyDocument) => [
      {
        onClick: () => onDocumentDownload(document),
        isLoading: isPolicyRefreshing,
        name: "Download",
        icon: <Download />,
        disabled: isRemovePolicyLoading,
      },
      ...(isDocumentRemovable(document)
        ? [
            {
              onClick: () => onDocumentRemove(document),
              isLoading: isRemovePolicyLoading,
              name: "Remove",
              icon: <Delete />,
              disabled: isPolicyRefreshing,
            },
          ]
        : []),
    ],
    [
      isPolicyRefreshing,
      isRemovePolicyLoading,
      onDocumentDownload,
      onDocumentRemove,
    ]
  );

  return (
    <>
      {policy.documents.filter(filterDocumentsToDisplay).map((document) => (
        <DocumentItem
          key={document.documentLocator}
          name={document.displayName.replace(
            environment.customDocumentSuffix,
            ""
          )}
          actions={getDocumentsActions(document)}
        />
      ))}
      {policy?.units[0]?.valuationReportUrl && (
        <DocumentItem
          key={policy.units[0].valuationReportUrl}
          name={DocumentDisplayName.ValuationReport}
          actions={[
            {
              onClick: () =>
                onValuationReportDownload(policy.units[0].valuationReportUrl),
              isLoading: isPolicyRefreshing,
              name: "Download",
              icon: <Download />,
              disabled: isRemovePolicyLoading,
            },
          ]}
        />
      )}
    </>
  );
}
